import { render, staticRenderFns } from "./beta-program.vue?vue&type=template&id=485ed5e2&"
import script from "./beta-program.vue?vue&type=script&lang=tsx&"
export * from "./beta-program.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports